import { PoolStorage } from './poolStorage';

export class PoolStorageManager<Entity> {
  private storagesMap: Map<string, PoolStorage<Entity>> = new Map();

  createStorage(
    storageKey: string,
    initialEntitiesPool?: Entity[],
  ): PoolStorage<Entity> {
    const storage = new PoolStorage<Entity>(initialEntitiesPool);

    this.storagesMap.set(storageKey, storage);

    return storage;
  }

  getStorage(storageKey: string): PoolStorage<Entity> | undefined {
    return this.storagesMap.get(storageKey);
  }

  getStoragesKeys(): string[] {
    return Array.from(this.storagesMap.keys());
  }

  removeStorage(storageKey: string): void {
    this.storagesMap.delete(storageKey);
  }

  manageEntities(action: (storage: PoolStorage<Entity>, key: string) => void) {
    const keys = this.getStoragesKeys();

    for (const key of keys) {
      const storage = this.getStorage(key);
      if (!storage) continue;

      action(storage, key);
    }
  }
}
